// extracted by mini-css-extract-plugin
export default {"newReportContainer":"NewReport_newReportContainer__dZg+-"};